<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && partecipant">
			<div class="col-sm-12">
				<div class="row">
					<!-- project -->
					<div class="form-group col-md-4">
						<label for="projectinput">{{ 'labels.project' | translate }}*</label>
						<input
							name="projectinput"
							[placeholder]="project?.name"
							required
							type="text"
							class="form-control"
							id="projectinput"
							disabled>

					</div>
					<!-- type -->
					<div class="form-group col-md-4">
						<label>{{'partecipant.entity' | translate}}</label>
						<ng-template [ngIf]="!partecipant.id">
							<select
								class="form-control custom-select"
								[(ngModel)]="partecipant.entity"
								required
								#entity="ngModel"
								name="entity"
								[ngClass]="{'is-invalid': editForm.submitted && entity.invalid}"
								(change)="resetEntity()">

								<option
									*ngFor="let e of partecipantType"
									[value]="e">
									{{'labels.' + e | translate}}
								</option>
							</select>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && entity.invalid"
								style="display: block;">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
						<ng-template [ngIf]="partecipant.id">
							<input
								name="entotyinput"
								[placeholder]="'labels.' + partecipant.entity | translate"
								required
								type="text"
								class="form-control"
								id="entityinput"
								disabled>
						</ng-template>

					</div>
					<!-- choose entity -->
					<ng-template [ngIf]="!partecipant.id">
						<div
							class="form-group col-md-4"
							*ngIf="!partecipant.entity">
						</div>
						<div
							class="form-group col-md-4"
							*ngIf="partecipant.entity">
							<label>
								{{ (partecipant.isCompany ? 'labels.choose-company' : 'labels.choose-consultant' )| translate}}
							</label>
							<ng-template [ngIf]="partecipant.isCompany">
								<app-entity-autocomplete
									entityName="company"
									entityField="name"
									entityFilterType="like"
									[entitySearch]="search.company"
									name="company"
									[(ngModel)]="partecipant.entityobj"
									placeholder
									required
									#companyautocomp="ngModel"
									[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
								</app-entity-autocomplete>
								<div
									class="invalid-feedback"
									*ngIf="editForm.submitted && companyautocomp.invalid"
									style="display: block;">
									{{'errors.required' | translate}}
								</div>

							</ng-template>
							<ng-template [ngIf]="partecipant.isConsultant">
								<app-entity-autocomplete
									entityName="consultant"
									entityField="name"
									entityFilterType="like"
									[entitySearch]="search.consultant"
									name="company"
									[(ngModel)]="partecipant.entityobj"
									placeholder
									required
									#companyautocomp="ngModel"
									[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
								</app-entity-autocomplete>
								<div
									class="invalid-feedback"
									*ngIf="editForm.submitted && companyautocomp.invalid"
									style="display: block;">
									{{'errors.required' | translate}}
								</div>
							</ng-template>
						</div>
					</ng-template>
					<ng-template [ngIf]="partecipant.id">
						<div class="form-group col-md-4">
							<label>{{ 'labels.entity-name'| translate}}</label>
							<input
								name="entityinput"
								[placeholder]="partecipant.entityobj?.name"
								required
								type="text"
								class="form-control"
								id="enttyinput"
								disabled>
						</div>

					</ng-template>

					<!-- budget -->
					<div class="form-group col-md-4">
						<label>{{'partecipant.budget' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="budget"
							[(ngModel)]="partecipant.budget"
							required
							#budget="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && budget.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && budget.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- leader -->
					<div class="form-group col-md-4">
						<input
							type="checkbox"
							class="form-check-input"
							name="leader"
							[(ngModel)]="partecipant.leader">
						<label class="form-check-label">{{'partecipant.leader' | translate}}</label>
					</div>
					<!-- description -->
					<div class="form-group col-md-12">
						<label>
							{{ 'partecipant.roledescr' | translate }}
						</label>
						<textarea
							[(ngModel)]="partecipant.roledescr"
							#description="ngModel"
							name="description"
							type="text"
							class="form-control"
							placeholder="{{ 'partecipant.roledescr' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && description.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && description.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
